import { render, staticRenderFns } from "./ManageFileForm.vue?vue&type=template&id=4e3420ac"
import script from "./ManageFileForm.vue?vue&type=script&lang=js"
export * from "./ManageFileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports